import React, {useState} from 'react';
import {Button, Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import CustomNavbar from "../../../components/CustomNavbar";
import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import comp from '../../../images/competencias.png';
const Maintenance = () => {
  const [show, setShow] = useState(true)
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return <>
    <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
    <SibebarSeleccionContratacion show={show} onShowSidebar={onShowSidebar} />
    <div className="custom-wrapper">
      <Container fluid>
        <div className="jumbotron ft-banner">
          <main>
            <h1>Selección y contratación</h1>
            <p className='mb-4 text-muted'>El módulo de selección y contratación tiene por objetivo la visualización del proceso de selección y contratación, donde se brinde seguimiento y control a las distintas fases de los procesos y resultado de candidatos.</p>
           {/*<Link 
              to='/seleccion-contratacion/administracion/motivos-plazas-vacantes'
              className="btn btn-primary rounded-pill">Agregar motivo de plaza vacante</Link>*/} 
          </main>
          <div className="figure">
            <img src={comp} alt="descriptores y perfiles" />
          </div>
        </div>
      </Container>
    </div>
  </>
}




export default Maintenance